import { Set as ImmutableSet } from 'immutable';
function createAction(name) {
  return `@@gates/${name}`;
}
export const SET_GATES = createAction('SET_GATES');
export const setGates = gates => ({
  type: SET_GATES,
  gates: ImmutableSet(gates)
});